"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yellow = exports.redDull = exports.red = exports.greenDull = exports.green = exports.damage = exports.all = exports.grays = exports.floor = exports.purpleDull = exports.purple = exports.g4 = exports.g3 = exports.g2 = exports.g1 = void 0;
exports.g1 = 0x0c1013;
exports.g2 = 0x3f4443;
exports.g3 = 0x727472;
exports.g4 = 0xc1c4c2;
exports.purple = 0x8b53b0;
exports.purpleDull = 0x4d2d62;
exports.floor = 0x96a6c0;
exports.grays = [exports.g1, exports.g2, exports.g3, exports.g4];
exports.all = [exports.g1, exports.g2, exports.g3, exports.g4, exports.purple];
exports.damage = 0x632e00;
exports.green = 0x8fc93a;
exports.greenDull = 0x44601a;
exports.red = 0xfd0d15;
exports.redDull = 0xa20207;
exports.yellow = 0xffb30f;
